import { defineStore } from 'pinia'
import { ref } from 'vue'

import type { DefaultBrandConfig } from '@xcel-next/rendering-tools'
import type { Environment } from '@xcel-next/core/enums'

// Detects { [key in Environment]?: V } records by checking if all keys are Environment values.
// Using [keyof T] extends [Environment] (not keyof T extends Environment) to avoid
// distributive conditional type behaviour on unions.
type IsEnvRecord<T> = [keyof T] extends [Environment] ? true : false

// Resolves env-keyed config fields to their value type.
// e.g. { production: string, staging: string, ... } → string
type ResolveEnvField<T> = IsEnvRecord<T> extends true
  ? NonNullable<T[keyof T & Environment]>
  : T

// DefaultBrandConfig stores several fields as { [key in Environment]: value } records
// since the server selects the active environment before passing config to the store,
// all those fields arrive as plain resolved values at runtime.
export type RsConfig = {
  [K in keyof DefaultBrandConfig]?: ResolveEnvField<NonNullable<DefaultBrandConfig[K]>>
}

export const useConfigStore = defineStore('config', () => {
  // State
  const rsConfig = ref<RsConfig>({})

  // Actions
  const setRsConfig = (config: RsConfig) => {
    rsConfig.value = config
  }

  return {
    rsConfig,
    setRsConfig
  }
})
